import { IQueryMediator } from 'core-ts-types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { ITimeOccurrenceDatatype, IRawTimeOccurrenceDatatype } from '../datastore/time/data_types';

// Given an existing TimeOccurrence object, and another TimeOccurrence object, take a property from the second and apply
// it to the first. An example of this is if you want to resize a TimeOccurrence object to match a from/to tm of another.
function copyTimePropCommandDefinition(
  defineCommand: any,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  updateTimeCommand: any,
  QueryMediator: IQueryMediator
) {
  return defineCommand(
    'copyTimePropCommand',
    function copyTimePropCommand(
      deferred: any,
      propHash: Object,
      property: string,
      timeWhosePropertyToCopy: ITimeOccurrenceDatatype,
      timeToUpdate: ITimeOccurrenceDatatype
    ) {
      let newTimeOccurrenceRawData: IRawTimeOccurrenceDatatype =
        ngTimeOccurrenceDataSource.serializeTime(timeWhosePropertyToCopy);

      propHash[property] = newTimeOccurrenceRawData[property];

      updateTimeCommand(timeToUpdate, propHash).then((builtTime: ITimeOccurrenceDatatype) => {
        QueryMediator.runQueries(ngTimeOccurrenceDataSource);
        deferred.resolve(builtTime);
      });
    }
  );
}

angular.module('ui-ng-calendar').factory('copyTimePropCommand', copyTimePropCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/copy_time_property.ts